import { createContext } from "react";
// Deliberately excludes views, query results with methods, callbacks and native handles.
// Each native history entry owns this small UI snapshot; popping the entry releases it.
export type RouteBodyValue = string | number | boolean | null | undefined;
export type Cell<T> = { current: T; listeners: Set<() => void> };
export type Snapshot = Map<string, Cell<unknown>>;
export const RouteBodyStateContext = createContext<{ prefix: string; snapshot: Snapshot } | null>(
  null,
);
